import * as React from 'react';
import { useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import {darken, lighten, alpha} from "@mui/material";
import Stack from '@mui/material/Stack';
import IconButton from '@mui/material/IconButton';
import { SnackbarContent } from 'notistack';
import Bs4MainDispatch from './Bs4MainDispatch';
import Bs4Kartoteka from './Bs4Kartoteka';
import { Dangerous } from '@mui/icons-material';

const multiplier = 2;
const bs4SnackbarVatiants = {
  0:  {autoHideDuration: multiplier * 3000,     variant: 'success'},
  1:  {autoHideDuration: null,                  variant: 'error'},
  2:  {autoHideDuration: multiplier * 2 * 3000, variant: 'warning'},
  3:  {autoHideDuration: null,                  variant: 'error'},
  4:  {autoHideDuration: multiplier * 3000,     variant: 'success'},
  11: {autoHideDuration: multiplier * 3000,     variant: 'info'},
  12: {autoHideDuration: multiplier * 3000,     variant: 'default'},
  21: {autoHideDuration: null,                  variant: 'error', persist: true},
  CENTER0: {autoHideDuration: null,             variant: 'success', persist: true, center: true},
  CENTER1: {autoHideDuration: null,             variant: 'error', persist: true, center: true},
  CENTER2: {autoHideDuration: null,             variant: 'warning', persist: true, center: true},
}

export const maxSnack = Infinity;
export let mouseOverSnackbar = false;
let snackbarCloseAllId = null;
const queuePendingSnackbar = [];
const enqueueSnackbarIds = new Map();

export const VariantBs4 = React.forwardRef((props, ref) => {
  const theme = useTheme();

  // console.log('...Variant.SnackBar...', props)

  const {backgroundColor, color, icon} = React.useMemo(() => {
    switch (props.variant) {
      case 'success': return {backgroundColor: theme.palette.success.main, color: theme.palette.success.contrastText, icon: "fa-solid fa-circle-check"};
      case 'error': return {backgroundColor: theme.palette.error.main, color: theme.palette.error.contrastText, icon: "fa-solid fa-circle-exclamation"};
      
      case 'warning': return {backgroundColor: theme.palette.warning.main, color: theme.palette.warning.contrastText, icon: "fa-solid fa-triangle-exclamation"};
      case 'info': return {backgroundColor: theme.palette.info.main, color: theme.palette.info.contrastText, icon: "fa-solid fa-circle-info"};
      default: return {backgroundColor: theme.palette.primary.main, color: theme.palette.primary.contrastText, icon: null};
    }
  }, [theme, props.variant]);

  // const backgroundColoralpha = alpha(lighten(backgroundColor, 0.8), 0.2);
  // const backgroundColoralpha = alpha(darken(backgroundColor, 0.8), 0.2);
  const backgroundColoralpha = alpha(backgroundColor, 0.3);
  // const backgroundColoralpha = '#00000033';
    

  const handleDismiss = React.useCallback(() => bs4CloseSnackbar(props.id), [props.id]);
  const handleDismissAll = React.useCallback(() => enqueueSnackbarIds.forEach((value, id) => bs4CloseSnackbar(id)), [enqueueSnackbarIds]);
  const handleClick = () => {    
    let bs4KartotekaIdSnackbar = props.bs4KartotekaId;    
    if (!bs4KartotekaIdSnackbar) {      
      bs4KartotekaIdSnackbar = Bs4Kartoteka.getFirst()?.bs4KartotekaId;
    }
    Bs4MainDispatch.commandParserAfter(bs4KartotekaIdSnackbar);
  }
  const handleMouseOverField = (e) => mouseOverSnackbar = e.type === 'mouseenter' ? true : false;

  if (props.variant === 'closeAll') return (
    <SnackbarContent ref={ref} style={{minWidth:'2px'}}>
      <Stack 
        sx={{width: '100%'}} 
        direction="row" 
        justifyContent="space-between" 
        alignItems="center"
        onMouseEnter={handleMouseOverField}
        onMouseLeave={handleMouseOverField}
      >
        <Box/>
        <Stack 
          sx={{
            backgroundColor: backgroundColor, 
            color: color,
            borderRadius: theme.shape.borderRadius+'px',
            padding: '8px',
            boxShadow: theme.shadows[3],            
          }} 
          direction="row" 
          justifyContent="space-between" 
          alignItems="center"
          spacing={1}
        >        
          <IconButton size="small" onClick={handleDismissAll} sx={{color: 'inherit'}}>
            <i className="fa-solid fa-xmark"></i>
          </IconButton>
        </Stack>      
      </Stack>
    </SnackbarContent>
  );

  if (props.bs4Center) {
    return (
      <SnackbarContent ref={ref}>
        <Stack 
          direction="column" 
          spacing={0} 
          sx={{
            justifyContent: "center", 
            alignItems: "center", 
            height: '100vh', 
            width: '100vw', 
            overflow: 'hidden',
            backgroundColor: backgroundColoralpha,
          }}
          onClick={handleDismiss}
        >
          <Stack        
            direction="row"         
            spacing={1}
            sx={{
              justifyContent: "space-between",
              alignItems: "center",            
              backgroundColor: backgroundColor, 
              color: color,
              borderRadius: theme.shape.borderRadius+'px',
              padding: '8px',
              boxShadow: theme.shadows[3],
              overflow: 'hidden',
            }}        
            onMouseEnter={handleMouseOverField}
            onMouseLeave={handleMouseOverField}
          >
            <Stack 
              direction="row" 
              spacing={1} 
              sx={{
                justifyContent: "flex-start", 
                alignItems: "center",
                maxHeight: '100%',
                flex: 1,
                overflow: 'hidden',
              }} 
            >
              <IconButton size="small" onClick={handleDismiss} sx={{color: 'inherit'}}>
                <i className={icon}></i>
              </IconButton>
              <Box sx={{overflow: 'auto', flex: 1, height:'100%', width: '100%'}}>
                <div dangerouslySetInnerHTML={{__html:props.message}} style={{overflowWrap: 'anywhere'}} onClick={handleClick}/>
              </Box>
            </Stack>
            <IconButton size="small" onClick={handleDismiss} sx={{color: 'inherit'}}>
              <i className="fa-solid fa-xmark"></i>
            </IconButton>
          </Stack> 
        </Stack>
      </SnackbarContent>
    )
  } 

  return (    
    <SnackbarContent ref={ref} style={{minWidth:'2px'}}>
      <Stack 
        sx={{
          width: '100%', 
          backgroundColor: backgroundColor, 
          color: color,
          borderRadius: theme.shape.borderRadius+'px',
          padding: '8px',
          boxShadow: theme.shadows[3],
        }}
        direction="row" 
        justifyContent="space-between" 
        alignItems="center"
        spacing={1}
        onMouseEnter={handleMouseOverField}
        onMouseLeave={handleMouseOverField}
      >
        <Stack direction="row" justifyContent="flex-start" alignItems="center" spacing={1}>
          <IconButton size="small" onClick={handleDismiss} sx={{color: 'inherit'}}>
            <i className={icon}></i>
          </IconButton>
          <div dangerouslySetInnerHTML={{__html:props.message}} onClick={handleClick}/>
        </Stack>
        <IconButton size="small" onClick={handleDismiss} sx={{color: 'inherit'}}>
          <i className="fa-solid fa-xmark"></i>
        </IconButton>
      </Stack>      
    </SnackbarContent>
  );
});

export let bs4Snackbar = null;
export const setBs4Snackbar = (newBs4Snackbar) => {
  bs4Snackbar = newBs4Snackbar;
}

export const bs4AddSnackbar = (message, type, bs4KartotekaId) => {
  // if (type === 2) type = 'CENTER1';  
  queuePendingSnackbar.push([message, type, bs4KartotekaId, new Date()]);
  // for (let i = 1; i < 10; i++) queuePendingSnackbar.push([message, type, bs4KartotekaId, new Date()]);
  bs4NextSnackbar();
}

const bs4NextSnackbar = () => {
  while (enqueueSnackbarIds.size < (maxSnack - 1) && queuePendingSnackbar.length > 0) {
    const bs4Snackbar = queuePendingSnackbar.shift();
    bs4RunSnackbar(...bs4Snackbar);
  }
}

export const bs4RunSnackbar = (message, type, bs4KartotekaId, date = new Date()) => {
  const handleClose = (e, reson, id) => {
    enqueueSnackbarIds.delete(id);
    if (enqueueSnackbarIds.size === 0 && snackbarCloseAllId) {
      const id = snackbarCloseAllId
      snackbarCloseAllId = null;
      bs4CloseSnackbar(id);
    }
    bs4NextSnackbar();
  }

  if (bs4Snackbar) {
    const variant = bs4SnackbarVatiants[type] || bs4SnackbarVatiants[11]
    
    const anchorOrigin = variant.center ? {anchorOrigin: {vertical: 'bottom', horizontal: 'center'}} : {};
    // const anchorOrigin = variant.center ? {anchorOrigin: {vertical: 'top', horizontal: 'center'}} : {};

    if (enqueueSnackbarIds.size === 0) {
      snackbarCloseAllId = bs4Snackbar.enqueueSnackbar('', {autoHideDuration: null, variant: 'closeAll', persist: true, onClose: handleClose, bs4KartotekaId: bs4KartotekaId});
    }

    const id = bs4Snackbar.enqueueSnackbar(message, {...variant, onClose: handleClose, ...anchorOrigin, bs4KartotekaId: bs4KartotekaId, bs4Center: variant.center});
    enqueueSnackbarIds.set(id, Date.now());
    return id;
  }
}

export const bs4CloseSnackbar = (id) => {
  enqueueSnackbarIds.delete(id);
  if (enqueueSnackbarIds.size === 0 && snackbarCloseAllId) {
    const id = snackbarCloseAllId;
    snackbarCloseAllId = null;
    if (bs4Snackbar) bs4Snackbar.closeSnackbar(id);    
  }
  if (bs4Snackbar) bs4Snackbar.closeSnackbar(id);
}

export const dismissToTime = (toTime) => {
  enqueueSnackbarIds.forEach((time, id) => {
    if (toTime > time) bs4CloseSnackbar(id);
  });
}